import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export function CartProvider({ children }) {
  const [cartItems, setCartItems] = useState(() => {
    try {
      const saved = localStorage.getItem('prayan_cart');
      return saved ? JSON.parse(saved) : [];
    } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem('prayan_cart', JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (poojaId) => {
    setCartItems(prev => {
      if (prev.includes(poojaId)) return prev;
      return [...prev, poojaId];
    });
  };

  const removeFromCart = (poojaId) => {
    setCartItems(prev => prev.filter(id => id !== poojaId));
  };

  const isInCart = (poojaId) => cartItems.includes(poojaId);

  const clearCart = () => setCartItems([]);

  const cartCount = cartItems.length;

  return (
    <CartContext.Provider value={{ cartItems, addToCart, removeFromCart, isInCart, clearCart, cartCount }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const context = useContext(CartContext);
  if (!context) throw new Error('useCart must be used within CartProvider');
  return context;
}
